import script from "./BattleRoyale.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleRoyale.vue?vue&type=script&setup=true&lang=js"

import "./BattleRoyale.vue?vue&type=style&index=0&id=c2c9c6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2c9c6e8"]])

export default __exports__